
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Portal = lazy(() => import('../pages/portal/page'));
const Home = lazy(() => import('../pages/home/page'));
const FreshFoods = lazy(() => import('../pages/fresh-foods/page'));
const Electronics = lazy(() => import('../pages/electronics/page'));
const Services = lazy(() => import('../pages/services/page'));
const CaseStudies = lazy(() => import('../pages/case-studies/page'));
const CaseStudy = lazy(() => import('../pages/case-study/page'));
const About = lazy(() => import('../pages/about/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Portal />,
  },
  {
    path: '/medical',
    element: <Home />,
  },
  {
    path: '/frozen-foods',
    element: <FreshFoods />,
  },
  {
    path: '/electronics',
    element: <Electronics />,
  },
  {
    path: '/medical/services',
    element: <Services />,
  },
  {
    path: '/medical/case-studies',
    element: <CaseStudies />,
  },
  {
    path: '/medical/case-studies/:slug',
    element: <CaseStudy />,
  },
  {
    path: '/medical/about',
    element: <About />,
  },
  {
    path: '/medical/terms',
    element: <Terms />,
  },
  {
    path: '/medical/privacy',
    element: <Privacy />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
